import { Link } from "react-router-dom";
import { faltaPraCotaZerar } from "@nhomi/core";
import { usePlano } from "@/lib/plano";

/* ============================================================
   "Suas estimativas de hoje acabaram"

   Um componente só porque duas telas dizem a mesma coisa — a de
   publicar e a do prato — e dizendo separado elas já tinham divergido:
   uma prometia "amanhã tem mais" e a outra "volta amanhã", e nenhuma das
   duas dizia QUANDO.

   O que mudou depois do primeiro teste no aparelho, e por quê:

   - **"amanhã" não é resposta.** Às onze da noite falta uma hora; às
     onze da manhã faltam treze. A conta sai de `faltaPraCotaZerar`, no
     core, pelo fuso de São Paulo — que é o que o servidor usa pra montar
     a chave do contador. O fuso do aparelho prometeria a hora errada pra
     quem está viajando.

   - **A porta do Pro virou botão.** Era um `btn-mini` cinza embaixo de
     dois parágrafos, do tamanho de um link de rodapé, no exato momento
     em que a pessoa encosta no limite. Agora é o botão da tela.

   - **E ela leva um motivo junto.** Chegar no Nhomi Pro sem nenhuma
     memória de por que se veio faz a tela parecer propaganda; com o
     motivo, ela abre respondendo o que acabou de acontecer.

   O que NÃO muda: o tom. Cota acabar não é erro, é o produto
   funcionando como combinado — então a primeira coisa dita é o que
   CONTINUA valendo (o prato sobe, a galera chuta, dá pra corrigir à
   mão), e não o que foi perdido.
   ============================================================ */

/** De onde o aviso está sendo mostrado. Muda uma frase, não o resto. */
export type Contexto = "publicar" | "prato";

/** O que levar pro `/assinar` pra ele saber por que a pessoa chegou. */
export const PORQUE_CALORIA = { porque: "cota-de-caloria" } as const;

export function CotaDeCaloria({ contexto }: { contexto: Contexto }) {
  const { assinante, tetoDeCaloriaHoje } = usePlano();
  const falta = faltaPraCotaZerar();

  return (
    <div className="cota-acabou">
      <div className="cota-titulo">
        {tetoDeCaloriaHoje === 1
          ? "Você já usou sua estimativa de hoje"
          : `Você já usou suas ${tetoDeCaloriaHoje} estimativas de hoje`}
      </div>

      <div className="cota-sub">
        {contexto === "publicar"
          ? "O prato sobe do mesmo jeito — a galera continua chutando a caloria, e você pode pedir a estimativa amanhã, na tela do prato."
          : "A galera continua chutando a caloria deste prato, e você pode pôr o valor à mão se souber."}
      </div>

      {/* O relógio é a informação que faltava, e por isso ele é a linha
          com peso: é ela que decide entre esperar e assinar. */}
      <div className="cota-relogio">
        Zera à meia-noite — <b>daqui a {falta}</b>.
      </div>

      {!assinante && (
        <Link className="btn btn-primary cota-botao" to="/assinar" state={PORQUE_CALORIA}>
          Soltar o limite com o Pro
        </Link>
      )}
    </div>
  );
}
